var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',[_vm._v("页面不存在："+_vm._s(_vm.$route.path))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }